<template>
  <list-index />
</template>

<script>
// Arşiv listesi liste ekranını kullanır. Ayrı bileşen olması, aynı layout içinde
// liste ↔ arşiv geçişinde ekranın yeniden oluşturulmasını (archived bayrağının okunmasını) sağlar.
import ListIndex from '@/views/Products/Index.vue'

export default {
  name: 'ProductsArchive',
  components: {
    ListIndex,
  },
}
</script>
